<!-- eslint-disable vue/no-mutating-props -->
<template>
  <VueDatePicker
    v-model="filter.value"
    :enable-time-picker="false"
    :min-date="filter.min || null"
    :max-date="filter.max || null"
    position="center"
    class="custom-input"
    locale="fr"
    auto-apply
    range
    :teleport="true"
    hide-input-icon
    @update:model-value="$emit('updateFilters', getDateFormat($event))"
  >
    <template #trigger>
      <v-text-field
        v-model="filter.value"
        :value="format(filter.value)"
        :label="filter.translation || $translate(`${translationName}.${filter.name}`)"
        :aria-label="filter.translation || $translate(`${translationName}.${filter.name}`)"
        class="filters-input pb-0"
        clearable
        variant="solo"
        @click:clear="$emit('updateFilters', null)"
      />
    </template>
  </VueDatePicker>
</template>
<script lang="ts">
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import moment from 'moment'

export default {
    name : "DateFilter",
    components : {VueDatePicker},
    props: {
        translationName: { type: String, required: true },
        filter: { type: Object, required: true },
    },
    emits: ['updateFilters'],
    data () {
        return {
            moment
        }
    },
    methods : {
        format (dateRange) {
            return dateRange ? 'du ' + dateRange.map(date =>this.$formatDate(date)).join(' au ') : ""
        },
        getDateFormat (dateRange) {
            return dateRange ? dateRange.map(date => moment(date).utc(1).format('YYYY-MM-DD')) : null
        },
    }
}
</script>
